import React from 'react'
import { Text, View } from 'react-native'
import { LazyImage } from '@dehaat/dds'
import { useTranslation } from 'react-i18next'
import DemoMaterialTileImage from 'app/components/requestType/DemoMaterialTileImage'
import { DemoMaterialRequest } from 'app/models/RequestFlow'

type Props = {
  item: DemoMaterialRequest
  styles: any
  getDisplayStatus: (latestStatus?: string) => string
  getStatusPillStyle: (latestStatus?: string) => any
  getStatusTextStyle: (latestStatus?: string) => any
}

const DemoRequestCardHeader = ({
  item,
  styles,
  getDisplayStatus,
  getStatusPillStyle,
  getStatusTextStyle,
}: Props) => {
  const { t } = useTranslation()

  return (
    <View style={styles.requestTopRow}>
      <View style={styles.requestProductBlock}>
        <View style={styles.requestProductImageWrap}>
          <LazyImage
            imageUrl={item.product_variant?.product_image}
            imgStyles={styles.requestProductImage}
            fallBackIcon={<DemoMaterialTileImage />}
          />
        </View>
        <View style={styles.requestProductInfo}>
          <Text style={styles.requestBrandText} numberOfLines={1}>
            {item.product_variant?.brand || t('demo_brand_fallback')}
          </Text>
          <Text style={styles.requestProductName} numberOfLines={1}>
            {item.product_variant?.product_name || '-'}
          </Text>
          <Text style={styles.requestVariantText} numberOfLines={1}>
            {item.product_variant?.attributes_name
              ? `${item.product_variant.attributes_name} x ${item.units || 0}`
              : `- x ${item.units || 0}`}
          </Text>
        </View>
      </View>
      <View style={styles.requestMetaCol}>
        <View style={styles.requestTypePill}>
          <Text style={styles.requestTypePillText}>{t('demo_material_issue')}</Text>
        </View>
        <View style={styles.requestStatusRow}>
          <Text style={styles.requestStatusLabel}>{t('status_label')}</Text>
          <View style={[styles.statusPill, getStatusPillStyle(item.latest_status)]}>
            <Text style={[styles.statusPillText, getStatusTextStyle(item.latest_status)]}>
              {getDisplayStatus(item.latest_status)}
            </Text>
          </View>
        </View>
      </View>
    </View>
  )
}

export default DemoRequestCardHeader
